import { useEffect, useRef, useState } from "react";
import { ChevronRight, Volume2 } from "lucide-react";
import { recordAttempt, say, useRoom } from "../../lib/zhuyinRoom";
import { RoomShell, groupOf } from "../../components/zhuyin/RoomUI";
import { TraceCanvas } from "../../components/lesson/TraceCanvas";

export default function ZhuyinTrace() {
  const { cards, childId } = useRoom();
  const [i, setI] = useState(0);
  const [done, setDone] = useState(false);
  const strip = useRef(null);
  const z = cards?.[i];
  useEffect(() => {
    if (!z) return;
    setDone(false);
    say(z);
    strip.current?.querySelector(`[data-i="${i}"]`)?.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
  }, [z, i]);
  const finish = () => { setDone(true); recordAttempt(childId, z.symbol, "room_trace", true); };
  return (
    <RoomShell title="只練描寫" testid="zhuyin-trace-page">
      {cards && (
        <>
          <div ref={strip} className="flex gap-2 overflow-x-auto pb-3 mb-6" data-testid="trace-picker">
            {cards.map((c, k) => (
              <button key={c.symbol} data-i={k} data-testid={`trace-pick-${c.symbol}`} onClick={() => setI(k)}
                className={`shrink-0 w-14 h-14 rounded-2xl text-3xl font-black border-2 ${k === i ? "text-white border-transparent" : "bg-white border-[#b9dcf0]"}`}
                style={k === i ? { background: groupOf(c).color } : { color: groupOf(c).color }}>{c.symbol}</button>
            ))}
          </div>
          <div className="flex flex-col items-center gap-5">
            <button data-testid="trace-play-btn" onClick={() => say(z)} className="flex items-center gap-3 font-round text-2xl text-[#14507f]">
              <span className="text-6xl font-black">{z.symbol}</span><Volume2 /> <span className="text-stone-500">{z.mnemonic}</span>
            </button>
            <TraceCanvas key={z.symbol} glyph={z.symbol} onComplete={finish} testid="trace-only" />
            {done && (
              <button data-testid="trace-next-btn" onClick={() => setI((i + 1) % cards.length)} className="kid-btn px-10 bg-[var(--jade)] text-white text-2xl font-round flex items-center gap-2">
                好棒！下一個 <ChevronRight />
              </button>
            )}
          </div>
        </>
      )}
    </RoomShell>
  );
}
